import { put, select } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { setEULA } from 'rdx/modules/systemDocs/slice';
import { getSessionLinks } from 'rdx/modules/auth/slice';

function* getEULA() {
  const sessionLinks = yield select(getSessionLinks);
  const link = sessionLinks.eula;

  const { success, data, error } = yield* makeRequest.link(link);
  if (success && data) {
    yield put(setEULA(data.unwrap()));
  } else {
    yield* putErrorActions({ error });
  }
  return null;
}

export default getEULA;
